import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
  },
  {
    title: 'Service Group',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
  },
  // {
  //   title: 'Forecast Days',
  //   field: 'forecastDays',
  //   filter: 'text',
  // },

  // {
  //   title: 'Invoice Amount ($)',
  //   field: 'price',
  //   filter: 'text',
  //   fieldType: 'currency',
  // },
  {
    title: 'Invoice Amount ($)', // Main header
    field: '', // No specific field for the group
    isHideColumnMenu: true, // Disable column menu for the main header
    filter: 'text', // Disable column menu for the main header
    children: [
      {
        title: 'Service',
        field: 'price',
        filter: 'text',
        fieldType: 'currency',
      },
      {
        title: 'Retest',
        field: 'invoiceRetestAmount',
        filter: 'text',
        fieldType: 'currency',
      },
    ],
  },
  {
    title: 'Accrual Amount ($)', // Main header for accrual
    field: '', // No specific field for the group
    isHideColumnMenu: true, // Disable column menu for the main header
    filter: 'text',
    children: [
      {
        title: 'Service',
        field: 'accrualAmount',
        filter: 'text',
        fieldType: 'currency',
      },
      {
        title: 'Retest',
        field: 'accrualRetestAmount',
        filter: 'text',
        fieldType: 'currency',
      },
    ],
  },
  {
    title: 'Status',
    field: 'isActive',
    filter: 'boolean',
    hide: false,
    width: '150',
  },
];
